import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { CraeteTitleCmsrDTO, ShopApiService } from '../api/shop-api.service';


const { createItem } = ShopApiService();

export const useCreateItem = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteTitleCmsrDTO) => {
            return createItem(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    message.success("Item added successfully");
                }


            },
        },
    );
};
